export enum LoanDecisionType_Enum {
  QuickQuote = -1,
  Approved = 0,
  Declined,
  Pending
}
